/**
 *
 * WidgetErrorBoundary
 *
 * Aísla los errores de render de un widget de reportes: si el widget falla,
 * solo ese recuadro muestra un mensaje y el resto de la página (header, menú,
 * demás widgets) sigue funcionando. Sin esto, un error en un widget desmonta
 * toda la aplicación y la pantalla queda en blanco (VLENG-12055).
 *
 */

import React from "react"
import PropTypes from "prop-types"
import { Empty } from "antd"

class WidgetErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error, info) {
    console.error("WidgetErrorBoundary", error, info)
  }

  componentDidUpdate(prevProps) {
    // Al cambiar de medición, división o segmento se vuelve a intentar el render
    if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ hasError: false })
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description="No se pudo cargar este indicador"
        />
      )
    }
    return this.props.children
  }
}

WidgetErrorBoundary.propTypes = {
  children: PropTypes.node,
  resetKey: PropTypes.string,
}

export default WidgetErrorBoundary
